// MenuComponent.jsx
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { RingLoader, ClipLoader } from "react-spinners";
import { Helmet } from "react-helmet";
const MenuComponent = () => {
    const [menuData, setmenuData] = useState([
        {
            id: 1,
            name: 'Menu 1',
            items: ['Item 1.1', 'Item 1.2', 'Item 1.3'],
        },
        {
            id: 2,
            title: 'Menu 2',
            items: ['Item 2.1', 'Item 2.2', 'Item 2.3'],
        },
        {
            id: 3,
            name: 'Menu 3',
            items: ['Item 3.1', 'Item 3.2', 'Item 3.3'],
        },
        {
            id: 4,
            name: 'Menu 3',
            items: [{ "id": "147", "name": "File h\u01b0\u1edbng d\u1eabn t\u1ed5ng h\u1ee3p", "code": "starter_level", "stt": "0", "url": "https:\/\/1drv.ms\/w\/s!Appe2G9EUxfJ_3fBjbojIITYD9QY?e=VKmtQa" }, { "id": "149", "name": "Ph\u00e1t v\u00e0 t\u1eaft kh\u1ea9n c\u1ea5p", "code": "starter_level", "stt": "0", "url": "https:\/\/1drv.ms\/w\/s!Appe2G9EUxfJ_3fBjbojIITYD9QY?e=VKmtQa" }],
        },
    ]);
    const [activeMenu, setActiveMenu] = useState(null);
    const [showMenuButton, setShowMenuButton] = useState(false);
    const [showMenu, setShowMenu] = useState(true);
    const [linkembed, setlinkembed] = useState(true);
    const [activeMenus, setActiveMenus] = useState([]);
    const [category, setcategory] = useState('');
    const [showtele, setshowtele] = useState('');
    const [loader, setloader] = useState('');
    const [showstart, setshowstart] = useState(false);
    const toggleMenu = (menuId) => {
        setActiveMenus((prevMenus) => {
            // Kiểm tra xem menuId đã được chọn trước đó chưa
            const index = prevMenus.indexOf(menuId);

            if (index !== -1) {
                // Nếu đã chọn, loại bỏ nó khỏi danh sách
                return prevMenus.filter((id) => id !== menuId);
            } else {
                // Nếu chưa chọn, thêm nó vào danh sách
                return [...prevMenus, menuId];
            }
        });
    };
    function embedtele(value) {
        const item = value;
        if (item) {
            // Trích xuất phần "freefltiktok" và "193" từ URL
            const [, guideName, guideId] = item.match(/\/([^\/]+)\/(\d+)$/);
            if (guideName && guideId) {
                console.log("Guide Name:", guideName);
                console.log("Guide ID:", guideId);
                const script = document.createElement("script");
                script.src = "https://telegram.org/js/telegram-widget.js?22";
                script.async = false;
                script.setAttribute("data-telegram-post", guideName + "/" + guideId);
                script.setAttribute("data-width", "100%");

                const telegramDiv = document.getElementById("telegram");
                // Xử lý khi script được tải xong
                script.onload = () => {
                    console.log("Telegram script loaded successfully!");
                    // setTimeout(() => {
                    //     setshowtele(true);
                    // }, 500);
                    // Thêm các logic xử lý sau khi script đã được tải xong ở đây
                };
                // Thêm script vào thẻ div có id="telegram"
                telegramDiv.appendChild(script);

                // Xóa script khi component bị hủy
                return () => {
                    telegramDiv.removeChild(script);
                };
            }
        }
    };
    const handleShowMenuButtonClick = () => {
        setShowMenu((showMenu) => !showMenu);
    };
    const show_ok = (value) => {
        setActiveMenu(value);
        // Tìm phần tử có id tương ứng
        const foundItem = menuData.flatMap(menu => menu.items).find(item => item.id === value);
        // Lấy URL nếu phần tử được tìm thấy
        const embedUrl = foundItem ? foundItem.url : '';
        const cate_item = foundItem ? foundItem.category : '';
        console.log(embedUrl);
        setlinkembed(embedUrl);
        setcategory(cate_item);
        setshowtele(false);
        setloader(true);
        setTimeout(() => {
            setloader(false);
        }, 500);
        setTimeout(() => {
            setshowtele(true);
        }, 100);
        setTimeout(() => {
            embedtele(embedUrl);
        }, 200);
        console.log(cate_item);
    };
    useEffect(() => {
        const handleResize = () => {
            setShowMenuButton(window.innerWidth < 768); // 768 là chiều rộng màn hình để xác định là điện thoại
        };

        window.addEventListener('resize', handleResize);
        handleResize(); // Kiểm tra kích thước màn hình khi component được render

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    useEffect(() => {
        laydulieu();
    }, []);
    function laydulieu() {
        axios
            .get('https://hust.media/api/wallet/e_commerce/document.php')
            .then(response => setmenuData(response.data),
                setTimeout(() => {
                    setshowstart(true);
                }, 200))
            .catch(error => console.log(error))
    }
    return (
        <div className="flex flex-col sm:flex-row bg-gray-100 h-screen">
            <Helmet>
                <title>CV Soru Maid Cafe</title>
            </Helmet>
            {!showstart ? (<>
                <div style={{ textAlign: "center" }} className="mt-5 mx-auto justify-center items-center">
                    <ClipLoader size={90} color="#8a2be2" />
                </div>
            </>) : (
                <>
                    <div className={`w-full sm:w-1/4 px-2 ${showMenuButton ? 'block' : 'hidden sm:block'}`}>
                        {showMenuButton && (
                            <button
                                className="w-full py-2 text-left border-b hover:bg-gray-300 transition-all duration-300"
                                onClick={handleShowMenuButtonClick}
                            >
                                <span className="font-semibold">Ẩn Hiện menu</span>
                            </button>
                        )}
                        {showMenu &&
                            (<>
                                {menuData.map((menu) => (
                                    <div key={menu.id} className="mb-1">
                                        <button
                                            className={`w-full py-3 ml-1 font-bold text-lg text-break text-wrap text-left border-b hover:bg-red-100 transition-all duration-300 ${activeMenus.includes(menu.id) && 'bg-red-100'}`}
                                            onClick={() => toggleMenu(menu.id)}
                                        >
                                            <span className="font-semibold">{menu.name}</span>
                                        </button>

                                        {activeMenus.includes(menu.id) && (
                                            <div className="mt-2">
                                                <ul>
                                                    {menu.items.map((item) => (
                                                        <li key={item.id} className="mb-1 ml-4 text-sm text-gray-600">
                                                            <button
                                                                onClick={() => show_ok(item.id)}
                                                                className={`bg-blue-500 hover:bg-red-500 text-break text-wrap text-base text-white font-bold py-1 px-4 rounded ${activeMenu === item.id && 'bg-red-500'}`}
                                                            >
                                                                {item.name}
                                                            </button>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </>)
                        }
                    </div>
                    <div className={`w-full sm:w-3/4 bg-gray-200 p-2 mt-1 sm:mt-0`}>
                        <div className="aspect-w-16 aspect-h-9">
                            {category == 'word' ?
                                (<>
                                    <iframe
                                        className="w-full h-full h-screen"
                                        src={linkembed}
                                        frameBorder="0"
                                        title="Embedded Document"
                                    >
                                        Đây là tài liệu{' '}
                                        <a target="_blank" rel="noopener noreferrer" href="https://office.com">
                                            Microsoft Office
                                        </a>{' '}
                                        được nhúng, hoạt động trên nền tảng{' '}
                                        <a target="_blank" rel="noopener noreferrer" href="https://office.com/webapps">
                                            Office
                                        </a>
                                        .
                                    </iframe>
                                </>) : (<>
                                    {category == 'telegram' ?
                                        (<>
                                            {!showtele ? (
                                                <>
                                                    <div className="mt-3 text-center">
                                                        Please wait a moment 😊
                                                    </div>
                                                </>
                                            ) :
                                                (<>
                                                    <div id="telegram"></div>
                                                </>)}
                                        </>)
                                        : (<></>)}
                                </>)}
                            {loader && (<>        <div className="text-center">
                                <ClipLoader size={80} color="#0000ff" />{" "}
                            </div></>)}
                        </div>
                    </div>
                </>)}
        </div>
    );
};

export default MenuComponent;